import React, { useState } from 'react'
import { Modal } from 'react-bootstrap'
import img from '../../Assets/Images/Login/no.svg'
import { t } from 'i18next'

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

const ModalCustomerCounted = ({
  showModalCustomerCounted,
  setShowModalCustomerCounted,
  infoCustomerCounted,
  addCustomerCounted,
  setInfoCustomerCounted,
}) => {
  const [error, setError] = useState({
    names: '',
    email: '',
    phone: '',
  })

  const handleChange = e => {
    const { id, value } = e.target

    // Teléfono: solo números y máx 8 dígitos
    if (id === 'phone' && !/^\d{0,8}$/.test(value)) return

    setInfoCustomerCounted(prev => ({
      ...prev,
      [id]: value,
    }))

    // Limpia error al escribir
    setError(prev => ({
      ...prev,
      [id]: '',
    }))
  }

  const validateForm = e => {
    e.preventDefault()

    const errors = {
      names: !infoCustomerCounted.names?.trim()
        ? 'customer.CustomerCounted.RequiredCamp'
        : '',
      email:
        infoCustomerCounted.email && !emailRegex.test(infoCustomerCounted.email)
          ? 'customer.CustomerCounted.invalidEmail'
          : '',
      phone:
        infoCustomerCounted.phone &&
        (infoCustomerCounted.phone.length < 7 ||
          infoCustomerCounted.phone.length > 8)
          ? 'customer.CustomerCounted.telephoneDigits'
          : '',
    }

    setError(errors)

    const hasErrors = Object.values(errors).some(Boolean)
    if (!hasErrors) addCustomerCounted()
  }

  const handleClose = () => {
    setError({ names: '', email: '', phone: '' })
    setShowModalCustomerCounted(false)
  }

  return (
    <Modal
      className="clienteContadoModal"
      show={showModalCustomerCounted}
      centered
      backdrop="static"
      backdropClassName="cliente-contado-backdrop"
      data-testid="modal-customer-counted">
      <form onSubmit={validateForm}>
        <div className="row">
          <div className="col-11">
            <h2>{t('customer.CustomerCounted.TitleModalSelect')}</h2>
          </div>
          <div className="col-1">
            <img
              className="img-close-modal"
              src={img}
              alt="close"
              data-testid="btn-close-modal-customer-counted"
              onClick={handleClose}
            />
          </div>
        </div>

        {/* Nombre */}
        <div className="container-inputs-customer-counted">
          <input
            type="text"
            id="names"
            className="insert-customer-counted"
            placeholder="Nombre y apellido*"
            value={infoCustomerCounted?.names || ''}
            onChange={handleChange}
            data-testid="input-names-customer-counted"
          />
          {error.names && (
            <p className="field-required-camp">{t(error.names)}</p>
          )}
        </div>

        {/* Email */}
        <div className="container-inputs-customer-counted">
          <input
            type="text"
            id="email"
            className="insert-customer-counted"
            placeholder="Ingresa tu correo electrónico"
            value={infoCustomerCounted?.email || ''}
            onChange={handleChange}
            data-testid="input-email-customer-counted"
          />
          {error.email && (
            <p className="field-required-camp">{t(error.email)}</p>
          )}
        </div>

        {/* Teléfono */}
        <div className="container-inputs-customer-counted">
          <input
            type="text"
            id="phone"
            className="insert-customer-counted"
            placeholder="Teléfono"
            value={infoCustomerCounted?.phone || ''}
            onChange={handleChange}
            data-testid="input-phone-customer-counted"
          />
          {error.phone && (
            <p className="field-required-camp">{t(error.phone)}</p>
          )}
        </div>

        <div className="container-button-customer-couented">
          <button
            type="submit"
            className="btn btn-continue-customer-counted"
            data-testid="btn-continue-customer-counted">
            {t('customer.CustomerCounted.Continue')}
          </button>
        </div>
      </form>
    </Modal>
  )
}

export default ModalCustomerCounted
